/**
 * Erros de dominio do modo demonstracao. Cada um diz exatamente o que faltou,
 * para o harness de teste e o console apontarem o arquivo a corrigir em vez de
 * a tela "funcionar" vazia.
 */

/** Motivo de uma requisicao nao ter sido respondida pelo adaptador de demonstracao. */
export type FixtureMissReason = 'missing' | 'write' | 'resolver-failed';

export interface FixtureMiss {
  readonly method: string;
  readonly path: string;
  readonly url: string;
  readonly reason: FixtureMissReason;
}

/**
 * Requisicao sem resposta de exemplo (GET nao cadastrado) ou escrita
 * (POST/PUT/PATCH/DELETE), que o tutorial nunca responde: a pessoa so
 * acompanha. Nunca e um 401 — o interceptor de refresh nao entra em acao.
 */
export class TutorialFixtureMissingError extends Error {
  readonly miss: FixtureMiss;

  constructor(miss: FixtureMiss, options?: { cause?: unknown }) {
    super(
      `[tutorial] sem resposta de exemplo para ${miss.method} ${miss.path} (${miss.reason}) — url: ${miss.url}`,
      options,
    );
    this.name = 'TutorialFixtureMissingError';
    this.miss = miss;
  }
}

/** O navegador nao deixou isolar o armazenamento: abrir o tutorial mexeria na sessao real. */
export class TutorialIsolationError extends Error {
  constructor(message: string, options?: { cause?: unknown }) {
    super(`[tutorial] ${message}`, options);
    this.name = 'TutorialIsolationError';
  }
}

/** O alvo `data-tourid` de um passo (ou de uma acao `prepare`) nao apareceu na tela. */
export class TutorialTargetMissingError extends Error {
  readonly target: string;

  constructor(target: string, detail: string) {
    super(`[tutorial] alvo [data-tourid="${target}"] nao encontrado: ${detail}`);
    this.name = 'TutorialTargetMissingError';
    this.target = target;
  }
}
